import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import messages from './messages';
import style from './style.module.less';

export const EmptyFulfillmentProviderListBodyMessage = () => (
  <FlexRow className={style['empty-body-message']}>
    <Text textType={TextType.Paragraph} value={messages.emptyFulfillmentProviderTableMessage} />
  </FlexRow>
);
